module.exports = __webpack_public_path__ + "img/layanan.1878ad3.png";